export default __webpack_public_path__ + "dynamic-box-hero.png";